export default __webpack_public_path__ + "static/media/ticketsIcon.2d794086.svg";